import * as React from "react";
import "./styles.scss";
import {
    Actions,
    ActionsEnum,
    CensusEquipmentStatusDetailsEnum,
    CensusEquipmentStatusesEnum,
} from "../../data/models/CensusEnums";
import {GlobalSuggestedAction} from "../../widgets/GlobalSuggestedAction";
import {Display} from "../../../../../components/Display";
import {JSONCensusEquipmentsActionsConfirmation} from "../../data/models/JSONCensusEquipmentsActionsConfirmation";
import {MappedDetailCount} from "../../data/models/JSONCensusSuggestedActionsAnalysisSummary";

import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";
import {StatusInfo} from "../StatusDescriptionTooltip";

declare var AppTranslations: AppTranslations;

interface SuggestedActionAccordionHeaderProps {
    statusIcon: CensusEquipmentStatusesEnum;
    headerName: string;
    equipmentCount: number;
    isOpen: boolean;
    suggestedAction: ActionsEnum;
    translatedActionsEnum: Actions;
    isMixedActionSelected: boolean;
    mergeConfirmedActions: (
        action: JSONCensusEquipmentsActionsConfirmation,
        isMixedActionSelected?: boolean,
    ) => void;
    onClick: (name: string) => void;
    status: CensusEquipmentStatusesEnum;
    statusDetail?: CensusEquipmentStatusDetailsEnum;
    confirmedAction?: JSONCensusEquipmentsActionsConfirmation;
    level?: number;
    detailCount?: MappedDetailCount[];
    availableActions: ActionsEnum[];
    containsEditedActions?: boolean;
    description: string
}

const getStatusIcon = (status: CensusEquipmentStatusesEnum) => {
    let iconName = "";
    let className = "";
    switch (status) {
        case CensusEquipmentStatusesEnum.FAIL:
            iconName = "cancel";
            className = "icon-error";
            break;
        case CensusEquipmentStatusesEnum.WARNING:
            iconName = "warning";
            className = "icon-warning";
            break;
        case CensusEquipmentStatusesEnum.OK:
            iconName = "check_circle";
            className = "icon-success";
            break;
    }
    return (
        <span className={`material-symbols-outlined status-icon ${className}`}>
			{iconName}
		</span>
    );
};

const containsAction = (detailCount: MappedDetailCount[]) => {
    return detailCount?.some((detail) => detail.suggestedAction !== undefined);
}

export const SuggestedActionAccordionHeader: React.FC<
    SuggestedActionAccordionHeaderProps
> = ({
         statusIcon,
         headerName,
         equipmentCount,
         isOpen,
         suggestedAction,
         level,
         onClick,
         detailCount,
         availableActions,
         translatedActionsEnum,
         containsEditedActions,
         description,
         ...rest
     }) => {
    const handleOnClick = () => {
        onClick(headerName);
    };
    return (
        <div
            className={`header-item first-level  ${level === 0 ? "header-action-with-icon" : "header-action-no-icon"} ${containsEditedActions ? "edited" : ""}`}
            onClick={handleOnClick}
        >
			<span
                className={`material-symbols-outlined chevron-icon ${isOpen ? "chevron-down" : ""}`}
            >
				chevron_right
			</span>
            <Display isVisible={level === 0}>{getStatusIcon(statusIcon)}</Display>
            <span className={`header-item-title ${containsEditedActions ? "edited" : ""}`}>
				{headerName + " (" + equipmentCount + ")"}
			</span>
            <div className={"action"}>
                <Display isVisible={availableActions && availableActions?.length > 1}>
                    <GlobalSuggestedAction
                        suggestedAction={suggestedAction}
                        availableActions={availableActions}
                        translatedActionsEnum={translatedActionsEnum}
                        {...rest} />
                </Display>
                <Display
                    isVisible={containsAction(detailCount)}
                >
                    <p className={"bold"}>{AppTranslations.massiveActions.censusCooler.suggestedActionInside}</p>
                </Display>
            </div>
            <div className={"info-icon"}>
                <StatusInfo description={description}/>
            </div>
        </div>
    );
};
